export default "__VITE_ASSET__RSW_pNd7__"